import moment from 'moment'

import { OnSchedRest }      from "../../../OnSchedRest";
import { OnSchedTemplates } from "../../../OnSchedTemplates";
import { OnSchedOnChange }  from '../../OnSchedOnChange';


export const InitSelectDomElements = (element, timezoneData) => {
  const urlCustomerStates = element.onsched.apiBaseUrl + "/customers/states";

  OnSchedRest.Get(urlCustomerStates, provinces => {
    InitTimezoneSelect(element, timezoneData);
    new Promise(resolve => resolve(InitCountrySelect(element, provinces)))
      .then(() => InitProvinceSelect(element, provinces))
    ;
  })
}

const InitCountrySelect = (element, provinces) => {
  const el = document.getElementById(element.id);
  const elCountry = document.getElementById('onsched-country');

  const countryNames = [...new Set(provinces.map(p => p.countryName))];
  const countryCodes = [...new Set(provinces.map(p => p.country))];
  let countries = [];

  for (var i = 0; i < countryNames.length; i++) {
    countries.push({ name: countryNames[i], code: countryCodes[i] })
  }

  elCountry.classList.toggle('loading');
  
  var toggleCountryDropdown = e => {
    if (e.target.dataset.tztoggle !== 'false') {
      elCountry.classList.toggle('active');
    }
  }
    
  var elCountryList = document.getElementById('onsched-country-options');
  elCountryList.innerHTML =  OnSchedTemplates.CountryOptions(countries);

  var elCountryBtn = document.getElementById('onsched-country-button');
  var elCountryInput = document.getElementById('onsched-country-hidden-input');
  let elCountrySelected = document.querySelector('[data-code="US"]');
  let countrySelectedData = {...elCountrySelected.dataset};
  
  Object.keys(countrySelectedData).map((countryData, idx) => elCountryBtn.dataset[countryData] = Object.values(countrySelectedData)[idx]);
  Object.keys(countrySelectedData).map((countryData, idx) => elCountryInput.dataset[countryData] = Object.values(countrySelectedData)[idx]);

  elCountryBtn.innerText = countrySelectedData.country;
  elCountryInput.value = countrySelectedData.code;

  if (elCountry.classList.contains('loading'))
    elCountry.classList.remove('loading');

  var elCountrySearch = document.getElementById('onsched-country-search-input');
  var elCountryOptions = document.querySelectorAll('.onsched-country-options .onsched-country-option');

  elCountryBtn.onclick = e => {
    toggleCountryDropdown(e);
    elCountrySearch.focus();
  };

  elCountryOptions.forEach(option => option.onclick = () => OnSchedOnChange.OnChangeCountry(element, option, provinces));
  
  elCountrySearch.onkeyup = e => {
    elCountryList.innerHTML = '';

    [...elCountryOptions].filter(opt => opt.innerText.toLowerCase().includes(e.target.value.toLowerCase()))
                    .forEach(opt => elCountryList.appendChild(opt))
  }
}

const InitProvinceSelect = (element, provinces) => {
  const el = document.getElementById(element.id);
  const elProvince = document.getElementById('onsched-province');
  
  elProvince.classList.toggle('loading');
  
  var toggleProvinceDropdown = e => {
    if (e.target.dataset.tztoggle !== 'false') {
      elProvince.classList.toggle('active');
    }
  }
  
  var elProvList = document.getElementById('onsched-province-options');
  elProvList.innerHTML =  OnSchedTemplates.ProvinceOptions(provinces);
  
  var elProvinceBtn = document.getElementById('onsched-province-button');
  var elProvinceInput = document.getElementById('onsched-province-hidden-input');
  let elProvinceSelected = [...document.querySelectorAll('.onsched-province-options .onsched-province-option')][0];
  let provinceSelectedData = {...elProvinceSelected.dataset}
  
  Object.keys(provinceSelectedData).map((provData, idx) => elProvinceBtn.dataset[provData] = Object.values(provinceSelectedData)[idx]);
  Object.keys(provinceSelectedData).map((provData, idx) => elProvinceInput.dataset[provData] = Object.values(provinceSelectedData)[idx]);

  elProvinceBtn.innerText = provinceSelectedData.name;
  elProvinceInput.value = provinceSelectedData.code;

  if (elProvince.classList.contains('loading'))
    elProvince.classList.remove('loading');

  var elProvSearch = document.getElementById('onsched-province-search-input');
  var elProvOptions = document.querySelectorAll('.onsched-province-options .onsched-province-option');

  elProvinceBtn.onclick = e => {
    toggleProvinceDropdown(e);
    elProvSearch.focus();
  };

  elProvOptions.forEach(option => option.onclick = () => OnSchedOnChange.OnChangeProvince(element, option, provinces));
  
  elProvSearch.onkeyup = e => {
    elProvList.innerHTML = '';

    [...elProvOptions].filter(opt => opt.innerText.toLowerCase().includes(e.target.value.toLowerCase()))
                    .forEach(opt => elProvList.appendChild(opt))
  }
}

export const InitTimezoneSelect = (element, timezoneData, existingResponse, dayClicked) => {
  const today = dayClicked ? dayClicked : new Date().toISOString().slice(0, 10);
  const elTimezone = document.getElementById('onsched-timezone');
  const urlCompanyTimezones = element.onsched.setupApiBaseUrl + `/companies/timezones/${today}`;

  elTimezone.classList.toggle('loading');

  var toggleTimezoneDropdown = e => {
    if (e.target.parentElement.dataset.tztoggle !== 'false') {
      elTimezone.classList.toggle('active');
    }
  }

  OnSchedRest.Get(urlCompanyTimezones, oldTimezones => {
    let timezones = oldTimezones;
    delete timezones.timezones[258];
    delete timezones.timezones[259];
    var elTzList = document.getElementById('onsched-timezone-options');
    elTzList.innerHTML =  OnSchedTemplates.TimezoneOptions(timezones, document.getElementById('onsched-timezone-search-input').value, element)
    
    var elTimezoneBtn = document.getElementById('onsched-timezone-button');
    var elTimezoneInput = document.getElementById('onsched-timezone-hidden-input');
    
    // let timezoneName = OnSchedHelpers.IsEmpty(element.params.timezoneName) ? moment.tz.guess() : element.params.timezoneName;
    let timezoneName = moment.tz.guess();
    let tzOffset = moment().utcOffset(timezoneName).utcOffset();
    var timezoneSelected;

    if (element.params.timezoneName) {
      timezoneName = element.params.timezoneName;

      timezoneSelected = timezones.timezones.filter(tz => tz.timezoneIanna === timezoneName)[0];
      tzOffset = timezoneSelected.tzOffset;
    }
    else if (element.params.tzOffset) {
      timezoneSelected = timezones.timezones.filter(tz => tz.tzOffset === parseInt(tzOffset))[0];
      timezoneName = timezoneSelected.timezoneIanna;
      tzOffset = element.params.tzOffset;
    }
    else {
      timezoneSelected = timezones.timezones.filter(tz => tz.timezoneIanna === moment.tz.guess())[0];
      if (!timezoneSelected) {
        timezoneSelected = timezones.timezones.filter(tz => tz.tzOffset === tzOffset)[0];
      }
    }

    // Check if loading existing data
    if (timezoneData?.timezoneOffset) {
      timezoneName = timezoneData.timezoneOffset;
    }
    
    if (!Object.keys({...elTimezoneBtn.dataset}).length) {
      elTimezoneInput.dataset.offset = timezoneSelected.tzOffset;
      elTimezoneInput.dataset.tz = timezoneSelected.timezoneIanna;
      elTimezoneInput.dataset.tzname = timezoneSelected.name;
      elTimezoneInput.value = timezoneSelected.timezoneIanna;
    
      elTimezoneBtn.dataset.offset = timezoneSelected.tzOffset;
      elTimezoneBtn.dataset.tz = timezoneSelected.timezoneIanna;
      elTimezoneBtn.dataset.tzname = timezoneSelected.name;
      elTimezoneBtn.innerText = element.options.timezoneIanaFormat ? timezoneSelected.timezoneIanna :timezoneSelected.name;
    }
  
    if (elTimezone.classList.contains('loading'))
      elTimezone.classList.remove('loading');
  
    var elTzSearch = document.getElementById('onsched-timezone-search-input');
    var elTzOptions = document.querySelectorAll('.onsched-timezone-options .onsched-timezone-option');
  
    elTimezoneBtn.onclick = e => {
      toggleTimezoneDropdown(e);
      elTzSearch.focus();
    };
  
    elTzOptions.forEach(option => option.onclick = e => OnSchedOnChange.OnChangeTimezone(e, element, existingResponse));

    elTzSearch.onkeyup = e => {
      elTzList.innerHTML =  OnSchedTemplates.TimezoneOptions(timezones, e.target.value, element);

      document.querySelectorAll('.onsched-timezone-options .onsched-timezone-option').forEach(option => option.onclick = e => OnSchedOnChange.OnChangeTimezone(e, element, existingResponse));
      // [...elTzOptions].filter(opt => opt.innerText.toLowerCase().includes(e.target.value.toLowerCase()))
      //                 .forEach(opt => elTzList.appendChild(opt))
    }
  })
}
